export class PremierServiceScheduleDTO{
    public id!: number;
    public added!: string;
    public customerPremierPartnerServiceConfigurationId!: number;
    public moovStepPremierServiceConfigurationId!: number;
    public customerId!: number;
    public clientId!: number;
    public executeOnOrAfter!: string;
    public startedAt!: string;
    public finishedAt!: string;
    public recurring!: boolean;
    public inProgress!: boolean;
    public finished!: boolean;
    public addedByUserId!: number;
    public optionalParameters!: string;
}